/** @format */

import { ButtonGroup } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import CustomTextButton from '../Buttons/CustomTextButton';
import GridContainer from '../Grid/GridContainer';
import GridItem from '../Grid/GridItem';

interface TabInterface {
    name: string;
    element: React.ReactElement;
}

interface CustomMinimalTabsProps {
    tabs: Array<TabInterface>;
    nonActiveColor?: string;
    activeColor?: string;
    resetActiveCard?: boolean;
    minHeight?: number;
}

export const CustomMinimalTabs = (props: CustomMinimalTabsProps): React.ReactElement => {
    const ACTIVE_COLOR = props.activeColor ? props.activeColor : 'primary';
    const NON_ACTIVE_COLOR = props.nonActiveColor ? props.nonActiveColor : 'tumblr';

    const [activeDialogCard, setActiveDialogCard] = useState<number>(0);

    const changeActiveCard = (param: { page: number }): void => {
        setActiveDialogCard(param.page);
    };

    useEffect(() => {
        setActiveDialogCard(0);
    }, [props.resetActiveCard]);

    return (
        <GridContainer style={{ minHeight: props.minHeight ? props.minHeight : 'auto' }}>
            <GridItem xs={12} md={12} lg={12}>
                <ButtonGroup variant="outlined" color="default" size="small">
                    {props.tabs.map((el: TabInterface, indx: number) => {
                        return (
                            <CustomTextButton
                                key={indx}
                                callback={changeActiveCard}
                                label={el.name}
                                buttonGroupSize="sm"
                                buttonGroupColor={activeDialogCard === indx ? ACTIVE_COLOR : NON_ACTIVE_COLOR}
                                callbackParam={{ page: indx }}
                            />
                        );
                    })}
                </ButtonGroup>
                <GridContainer>
                    <GridItem xs={12} md={12} lg={12}>
                        {props.tabs[activeDialogCard].element}
                    </GridItem>
                </GridContainer>
            </GridItem>
        </GridContainer>
    );
};
